import { call, takeEvery } from 'redux-saga/effects';
import * as api from 'api';
import { CameraFnAction, PtzLockAction, PtzMoveAction, PtzSetLocationAction } from 'actions/cameraActions';


export function* cameraFunctionWatcher() {
    yield takeEvery('CAMERA_FN', cameraFunctionSaga);
}

export function* cameraFunctionSaga(action: CameraFnAction) {
    const { deviceId, commandId } = action.payload;
    try {
        yield call(api.camera.postCameraFn, deviceId, commandId);
    }
    catch (err) {
        console.error(err);
    }
}



export function* ptzMoveWatcher() {
    yield takeEvery('PTZ_MOVE', ptzMoveSaga);
}

export function* ptzMoveSaga(action: PtzMoveAction) {
    const { deviceId, x, y, z, speed } = action.payload;
    try {
        yield call(api.camera.postPtzMove, deviceId, x, y, z, speed);
    }
    catch (err) {
        console.error(err);
    }
}



export function* ptzSetLocationWatcher() {
    yield takeEvery('PTZ_SET_LOCATION', ptzSetLocationSaga);
}

export function* ptzSetLocationSaga(action: PtzSetLocationAction) {
    const { deviceId, locationId } = action.payload;
    try {
        yield call(api.camera.postPtzLocation, deviceId, locationId);
    }
    catch (err) {
        console.error(err);
    }
}



export function* ptzLockWatcher() {
    yield takeEvery('PTZ_LOCK', ptzLockSaga);
}

export function* ptzLockSaga(action: PtzLockAction) {
    const { deviceId, lock } = action.payload;
    try {
        yield call(api.camera.postPtzLock, deviceId, lock);
    }
    catch (err) {
        console.error(err);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/cameraSagas.ts